(function () {
  if (window.__mgLightbox) return;
  window.__mgLightbox = true;

  var dlg, imgEl, capEl, counterEl, prevBtn, nextBtn, items = [], idx = 0;

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'mg-lightbox';
    dlg.innerHTML =
      '<button type="button" class="mg-lightbox__close" aria-label="Close">✕</button>' +
      '<button type="button" class="mg-lightbox__nav mg-lightbox__prev" aria-label="Previous">‹</button>' +
      '<figure class="mg-lightbox__figure"><img class="mg-lightbox__img" alt=""><figcaption class="mg-lightbox__caption"></figcaption></figure>' +
      '<button type="button" class="mg-lightbox__nav mg-lightbox__next" aria-label="Next">›</button>' +
      '<div class="mg-lightbox__counter"></div>';
    document.body.appendChild(dlg);
    imgEl = dlg.querySelector('.mg-lightbox__img');
    capEl = dlg.querySelector('.mg-lightbox__caption');
    counterEl = dlg.querySelector('.mg-lightbox__counter');
    prevBtn = dlg.querySelector('.mg-lightbox__prev');
    nextBtn = dlg.querySelector('.mg-lightbox__next');
    dlg.querySelector('.mg-lightbox__close').addEventListener('click', function () { dlg.close(); });
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.classList.contains('mg-lightbox__figure')) dlg.close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });
    var sx = null;
    dlg.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    dlg.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
      sx = null;
    }, { passive: true });
  }

  function preload(i) {
    var it = items[i];
    if (it && it.full) { var im = new Image(); im.src = it.full; }
  }

  function render() {
    var it = items[idx]; if (!it) return;
    imgEl.alt = it.caption || '';
    // show cached thumbnail instantly, then swap to full when ready
    imgEl.src = it.thumb || it.full;
    if (it.full && it.full !== it.thumb) {
      var f = new Image();
      f.onload = function () { if (items[idx] === it) imgEl.src = it.full; };
      f.src = it.full;
    }
    capEl.textContent = it.caption || '';
    capEl.style.display = it.caption ? '' : 'none';
    var multi = items.length > 1;
    counterEl.textContent = multi ? (idx + 1) + ' / ' + items.length : '';
    prevBtn.style.display = multi ? '' : 'none';
    nextBtn.style.display = multi ? '' : 'none';
    if (multi) { preload((idx + 1) % items.length); preload((idx - 1 + items.length) % items.length); }
  }
  function go(d) { idx = (idx + d + items.length) % items.length; render(); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.meta-gallery__open');
    if (!btn) return;
    var gallery = btn.closest('.meta-gallery');
    if (!gallery || gallery.getAttribute('data-lightbox') === 'false') return;
    e.preventDefault();
    if (!dlg) build();
    var btns = Array.prototype.slice.call(gallery.querySelectorAll('.meta-gallery__open'));
    items = btns.map(function (b) {
      var im = b.querySelector('img');
      return { full: b.getAttribute('data-full'), thumb: im ? (im.currentSrc || im.src) : '', caption: b.getAttribute('data-caption') || '' };
    });
    idx = btns.indexOf(btn);
    render();
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  });
})();
